// extracted by mini-css-extract-plugin
export default {"container":"RootErrorBoundary_container__R49cW","message":"RootErrorBoundary_message__k8WT6","button":"RootErrorBoundary_button__ZfHpp"};